import { TextSelection } from 'prosemirror-state'

import type { Command } from 'common/Prose/Commands'

/**
 * Break out of a text node with inline code, using a little trick: Insert a
 * zero-width space after the node if there is none yet to produce another
 * position directly outside the text node.
 */
export const breakOutOfInlineCode =
  (side: 'left' | 'right'): Command =>
  ({ doc, schema, selection, tr }, dispatch) => {
    const { $from, empty, from } = selection

    if (!empty) return false

    if (side === 'left') {
      // if we are not on the start of a inline code text block
      if (!schema.marks.code.isInSet($from.nodeAfter?.marks || [])) return false
      if (schema.marks.code.isInSet($from.nodeBefore?.marks || [])) return false

      // if there is already a zero-width space
      if ($from.nodeBefore?.textContent?.endsWith('\u200B')) return false

      tr.insert(from, schema.text('\u200B'))
      tr.setSelection(TextSelection.create(tr.doc, from - 1))
    } else {
      // if we are not on the end of a inline code text block
      if (!schema.marks.code.isInSet($from.nodeBefore?.marks || [])) return false
      if (schema.marks.code.isInSet($from.nodeAfter?.marks || [])) return false

      // if there is already a zero-width space
      if ($from.nodeAfter?.textContent?.startsWith('\u200B')) return false

      tr.insert(from, schema.text('\u200B'))
      tr.setSelection(TextSelection.create(tr.doc, from + 1))
    }

    if (tr.docChanged) dispatch?.(tr)

    return tr.docChanged
  }
